// extracted by mini-css-extract-plugin
export default {"freeTrialExpiredMessage":"SubscriptionManager_freeTrialExpiredMessage__b7lxf","upgradeButton":"SubscriptionManager_upgradeButton__vOjnR"};